import { $host } from ".";

export const createFeedback = async (name: string, email: string, text: string) => {
    const {data} = await $host.post('feedback', {name, email, text});
    return data;
};